import * as Yup from 'yup';
import { validatePersonNo } from 'us.collection.case/functions';
import {
	organizationNoValidate,
	personNoValidation,
} from 'us.collection/functions';

export default () => {
	return Yup.object().shape({
		lastName: Yup.string().required(
			'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
		),
		country: Yup.string().required(
			'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
		),
		email: Yup.string()
			.email(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.nullable(),
		otherPartyRoleType: Yup.string().required(
			'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
		),
		nin: Yup.string().when('otherPartyType', {
			is: (val) => val === 'N',
			then: Yup.string()
				.typeError(
					'US.COLLECTION.VALIDATIONS:INVALID.FIELD_VALUE_IS_IN_INCORRECT_FORMAT'
				)
				.test(
					'organizationNo',
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD',
					(val: any) => {
						val =
							typeof val ==
							'undefined'
								? ''
								: val.toString();
						return organizationNoValidate(
							val
						);
					}
				),
			otherwise: Yup.string()
				.typeError(
					'US.COLLECTION.VALIDATIONS:INVALID.FIELD_VALUE_IS_IN_INCORRECT_FORMAT'
				)
				.test(
					'personNo',
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD',
					(value: any) => {
						let isValidDate = true;
						let val = value
							?.toString()
							.replaceAll(/\D/g, '');
						if (val) {
							if (isNaN(val)) {
								isValidDate =
									false;
							} else {
								isValidDate =
									validatePersonNo(
										val
									).isValid;
							}
						} else {
							val = '';
						}
						return (
							isValidDate ||
							val?.toString() === ''
						);
					}
				)
				.test(
					'personNo',
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD',
					(val: any) => {
						val =
							typeof val ==
							'undefined'
								? ''
								: val.toString();
						return personNoValidation(val);
					}
				),
		}),
		smsNo: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
		zipCode: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.when('addrUnknown', {
				is: false,
				then: Yup.string().required(
					'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
				),
			}),
		zipName: Yup.string()
			.nullable()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.when(['zipCode'], {
				is: (zipCode) => {
					zipCode =
						typeof zipCode == 'undefined'
							? ''
							: zipCode;
					return zipCode?.toString().length !== 0;
				},
				then: Yup.string()
					.required(
						'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
					)
					.test(
						'zipNameDigit',
						'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD',
						(val: any) => {
							let value =
								typeof val ==
								'undefined'
									? ''
									: val;
							return !/^\d+$/.test(
								value
							);
						}
					),
			}),
		municipalityCode: Yup.number()
			.nullable()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			),

		municipalityName: Yup.string().nullable(),

		telephoneNo: Yup.string()
			.typeError(
				'US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD'
			)
			.matches(
				/^\d{4,15}$/g,
				'US.COLLECTION.VALIDATIONS:REQUIRED.THE_NUMBER_SHOULD_CONTAIN_BETWEEN_4_AND_15_DIGITS'
			)
			.nullable(),
	});
};
